export function convertObjectToQueryString(obj = {}, assignCharacter = '=', separator = '&'): string {
  return Object.entries(obj)
    .map(([key, value]) => `${key}${assignCharacter}${value}`)
    .join(separator);
}
